var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-4" },
    [
      _c("modal-filter", {
        attrs: { onfilter: _vm.onfilter, filter: _vm.filter },
        on: {
          onclose: function ($event) {
            _vm.onfilter = false
          },
          onfilter: function ($event) {
            return _vm.ONFILTER()
          },
        },
      }),
      _vm._v(" "),
      _vm.ondelete
        ? _c("modal-delete", {
            attrs: { ondelete: _vm.ondelete, id: _vm.id },
            on: {
              onclose: function ($event) {
                _vm.ondelete = false
              },
              onreload: function ($event) {
                return _vm.ONFILTER()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onreload
        ? _c("modal-reload", {
            attrs: { onreload: _vm.onreload, item: _vm.item },
            on: {
              onclose: function ($event) {
                _vm.onreload = false
              },
              onreload: _vm.FRESH,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "vstack gap-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column flex-md-row gap-3 justify-content-between",
              },
              [
                _c(
                  "form",
                  {
                    staticClass: "d-flex gap-3 row",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.FILTER()
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.onfilter = true
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-funnel me-2" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Filtro")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "vr opacity-20 mx-3" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-xs text-primary" }, [
                            _vm._v(_vm._s(_vm.count_filter)),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.SORT()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "me-2",
                            class:
                              _vm.filter.sortDesc == "ASC"
                                ? "bi bi-sort-alpha-up"
                                : "bi bi-sort-alpha-down-alt",
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.filter.sortDesc))]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 px-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "input-group input-group-sm input-group-inline",
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.search,
                                expression: "filter.search",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", placeholder: "Buscar..." },
                            domProps: { value: _vm.filter.search },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filter,
                                  "search",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-primary",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm.loading == "filter"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Buscar")]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.CLEAR()
                            },
                          },
                        },
                        [
                          _vm.loading == "clear"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Limpiar")]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body p-0" },
                [
                  [
                    _c("v-data-table", {
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.headers.filter(function (e, i) {
                          if (_vm.role == 1) {
                            return e
                          } else {
                            if (i != 5) {
                              return e
                            }
                          }
                        }),
                        items:
                          _vm.loading == "table" ||
                          _vm.loading == "sort" ||
                          _vm.loading == "filter" ||
                          _vm.loading == "clear"
                            ? []
                            : _vm.items.data,
                        options: _vm.options,
                        "server-items-length": _vm.items.total,
                        loading:
                          _vm.loading == "table" ||
                          _vm.loading == "sort" ||
                          _vm.loading == "filter" ||
                          _vm.loading == "clear",
                        "footer-props": {
                          "items-per-page-options": [5, 10, 50, 100],
                        },
                      },
                      on: {
                        "update:options": function ($event) {
                          _vm.options = $event
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.awb",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "text-decoration-none",
                                    attrs: {
                                      to: {
                                        name: "AwbDetail",
                                        params: { awb: item.awb },
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(item.awb) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.state_id",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                item.state_id == 20
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-dark badge-pill",
                                      },
                                      [_vm._v("Cerrado")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-success badge-pill",
                                      },
                                      [_vm._v("Abierto")]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.created_at",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm._f("DATE")(item.created_at)) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.open",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "a",
                                                _vm._g(
                                                  _vm._b({}, "a", attrs, false),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      staticClass:
                                                        "btn btn-info btn-m",
                                                      attrs: {
                                                        to: {
                                                          name: "AwbDetail",
                                                          params: {
                                                            awb: item.awb,
                                                          },
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("small", [
                                                        _c("i", {
                                                          staticClass:
                                                            "bi bi-card-list",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_vm._v(" "), _c("small", [_vm._v("Ver")])]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.delete",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.globalViewOption("AwbDelete") &&
                                item.state_id != 20
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-danger btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.DELETE(
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("small", [
                                                        _c("i", {
                                                          staticClass:
                                                            "bi bi-trash3",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Eliminar")]),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-danger btn-m",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass: "bi bi-trash3",
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.print",
                            fn: function (ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex gap-3" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-neutral btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.PRINT(
                                                                item.awb,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                        },
                                                        [
                                                          _vm.print_wr.filter(
                                                            function (e) {
                                                              return e == index
                                                            }
                                                          ).length == 1
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "spinner-border spinner-border-sm mb-0",
                                                                  attrs: {
                                                                    role: "status",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Loading..."
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("i", {
                                                                staticClass:
                                                                  "bi bi-printer",
                                                              }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v("Imprimir Warehouse Receipt"),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-danger btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.PRINT_PAGES(
                                                                item.awb,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                        },
                                                        [
                                                          _vm.print_pages.filter(
                                                            function (e) {
                                                              return e == index
                                                            }
                                                          ).length == 1
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "spinner-border spinner-border-sm mb-0",
                                                                  attrs: {
                                                                    role: "status",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Loading..."
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("i", {
                                                                staticClass:
                                                                  "bi bi-newspaper",
                                                              }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Imprimir TAG")]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.download",
                            fn: function (ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-success btn-m mr-1",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.DOWNLOAD_PDF(
                                                                item.awb,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("small", [
                                                        _vm.save_pdf.filter(
                                                          function (e) {
                                                            return e == index
                                                          }
                                                        ).length == 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "spinner-border spinner-border-sm mb-0",
                                                                attrs: {
                                                                  role: "status",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "sr-only",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Loading..."
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _c("i", {
                                                              staticClass:
                                                                "bi bi-file-pdf",
                                                            }),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Download PDF")]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-success btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.DOWNLOAD_EXCEL(
                                                                item.awb,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("small", [
                                                        _vm.save_excel.filter(
                                                          function (e) {
                                                            return e == index
                                                          }
                                                        ).length == 1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "spinner-border spinner-border-sm mb-0",
                                                                attrs: {
                                                                  role: "status",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "sr-only",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Loading..."
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _c("i", {
                                                              staticClass:
                                                                "bi bi-file-earmark-excel",
                                                            }),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Download XLS")]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.close",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.globalViewOption("AwbUpdate")
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-m",
                                                          class:
                                                            item.state_id == 19
                                                              ? "btn-danger"
                                                              : "btn-dark",
                                                          attrs: {
                                                            type: "button",
                                                            disabled:
                                                              _vm.role != 1 &&
                                                              item.state_id ==
                                                                20,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.ACTION(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("small", [
                                                        _c("i", {
                                                          class:
                                                            item.state_id == 19
                                                              ? "bi bi-unlock"
                                                              : "bi bi-lock",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v(
                                            _vm._s(
                                              item.state_id == 19
                                                ? "Cerrar"
                                                : "Abrir"
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-light btn-m",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            class:
                                              item.state_id == 19
                                                ? "bi bi-unlock"
                                                : "bi bi-lock",
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-sm col-12" }, [
              _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Manifiestos")]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _c("i", { staticClass: "bi bi-search" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Listado")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }